// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"55776e65","100":"55776e65","103":"55776e65","241":"55776e65","805":"55776e65"}[chunkId] + ".chunk.css";
};